import { render } from "./TotalesTerminados.vue?vue&type=template&id=6a2f3680&scoped=true"
import script from "./TotalesTerminados.vue?vue&type=script&lang=js"
export * from "./TotalesTerminados.vue?vue&type=script&lang=js"

import "./TotalesTerminados.vue?vue&type=style&index=0&id=6a2f3680&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dyamd\\OneDrive\\Documents\\PROYECTOS\\ceramicas\\mi-stock-ceramicas-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2f3680"]])

export default __exports__